import Link from "next/link";
import Image from "next/image";
export const BrandIconLink = () => (
    <>
        <Link href="/" className="w-12 rounded-full">
            <Image
                width="128"
                height="128"
                src="/kooleyy.png"
                alt="Kooleyy's Avatar"
                className="rounded-full"
                priority={true}
            />
        </Link>
    </>
)